// extracted by mini-css-extract-plugin
export default {"content":"AuthPage_content__CnWV3","tabs":"AuthPage_tabs__52JS-"};